module.exports = __webpack_public_path__ + "static/media/Logo_4.8558c8ec.png";